module.exports = __webpack_public_path__ + "99d51996b0632bf9e352ba5a0ee48296.png";